import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dropdown } from 'common-components'
import { FormGroup } from 'reactstrap'
import { getSelectedPlan } from 'quick-quote/product-common/coverage-plan/selectors'
import { getHealthToppingOptionsPlans } from 'quick-quote/product-health-topping/coverage-plan/selectors'

import { selectHealthToppingPlan } from '../../actions'

const BasicPlanSelection = ({ healthToppingOptionsPlans, selectedPlan, selectHealthToppingPlan }) => {
  return (
    <FormGroup className={'basic-plan-selection item basic'}>
      <div className="form-group-title">
        <span className="form-group-title-text">สัญญาหลัก</span>
      </div>
      <div className="options option-labels">
        <label>เลือกแผน</label>
      </div>
      <Dropdown
        className="basic-plan form-control"
        options={healthToppingOptionsPlans}
        onChange={(planCode) => {
          selectHealthToppingPlan(planCode)
        }}
        value={selectedPlan}
      />
    </FormGroup>
  )
}

const mapStateToProps = (state) => ({
  healthToppingOptionsPlans: getHealthToppingOptionsPlans(state),
  selectedPlan: getSelectedPlan(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectHealthToppingPlan: bindActionCreators(selectHealthToppingPlan, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BasicPlanSelection)
